import React from 'react';
import Card from '../../ui/Card';
import { AlertTriangleIcon } from 'lucide-react';
const CustomerTable: React.FC = () => {
  const customers = [{
    name: 'Maruti Suzuki',
    revenue: 18.5,
    margin: 15.2,
    risk: 'Low'
  }, {
    name: 'Hyundai',
    revenue: 15.4,
    margin: 14.8,
    risk: 'Low'
  }, {
    name: 'Tata Motors',
    revenue: 13.8,
    margin: 13.5,
    risk: 'Medium'
  }, {
    name: 'Mahindra',
    revenue: 10.6,
    margin: 14.1,
    risk: 'Low'
  }, {
    name: 'Honda',
    revenue: 9.2,
    margin: 15.8,
    risk: 'Low'
  }, {
    name: 'Toyota',
    revenue: 7.8,
    margin: 16.2,
    risk: 'Low'
  }, {
    name: 'Kia',
    revenue: 7.0,
    margin: 14.5,
    risk: 'Medium'
  }, {
    name: 'VW Group',
    revenue: 6.3,
    margin: 13.8,
    risk: 'Medium'
  }, {
    name: 'Renault-Nissan',
    revenue: 5.6,
    margin: 12.9,
    risk: 'High'
  }, {
    name: 'MG Motor',
    revenue: 4.7,
    margin: 13.2,
    risk: 'Medium'
  }];
  const getRiskColor = (risk: string) => {
    switch (risk) {
      case 'Low':
        return 'text-green-600 bg-green-50';
      case 'Medium':
        return 'text-yellow-600 bg-yellow-50';
      case 'High':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };
  return <Card className="p-6" data-id="element-8430">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8431">
        Customer Concentration Analysis
      </h3>
      <div className="overflow-x-auto" data-id="element-8432">
        <table className="w-full" data-id="element-8433">
          <thead data-id="element-8434">
            <tr className="border-b border-gray-200" data-id="element-8435">
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8436">
                Customer
              </th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8437">
                Revenue %
              </th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8438">
                Margin %
              </th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-8439">
                Risk Score
              </th>
            </tr>
          </thead>
          <tbody data-id="element-8440">
            {customers.map((customer, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-8441">
                <td className="py-3 px-4 text-sm text-gray-800" data-id="element-8442">
                  {customer.name}
                </td>
                <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-8443">
                  {customer.revenue}%
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-8444">
                  {customer.margin}%
                </td>
                <td className="py-3 px-4 text-center" data-id="element-8445">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getRiskColor(customer.risk)}`} data-id="element-8446">
                    {customer.risk === 'High' && <AlertTriangleIcon size={12} className="mr-1" data-id="element-8447" />}
                    {customer.risk}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
};
export default CustomerTable;